<div class="dialog-content-wrapper">
    <mat-toolbar class="bg-primary m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center" class="text-white">
            <span class="title dialog-title">Firma Electrónica</span>
            <div class="close-button" align="end">
                <button mat-icon-button (click)="dialogRef.close()" aria-label="Close dialog">
                <mat-icon class="text-white">close</mat-icon>
            </button>
            </div>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-2 m-0" fusePerfectScrollbar>
        <evk-firma-electronica
            [idDiligencia]="idDiligencia"
            [username]="username"
            [hash]="hash"
            [message]="message"
            [signedMessageEncode]="encode"
            (errorMessage)="errorMessage($event)"
            (signedMessage)="signedMessage($event)"
            (valid)="valid($event)"
            (loading)="loading($event)"
            [rfc]="rfc"
        >
        </evk-firma-electronica>
    </div>
</div>
